import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import OutputParams from '../../OutputParams';

/**
 * Result 响应渲染器
 */
function ResultRenderer({ resultType, onSelect }) {
  return (
    <ErrorBoundary
      fallbackRender={() => <div></div>}
      onReset={() => {}}
    >
      <OutputParams
        resultType={resultType}
        onSelect={onSelect}
      />
    </ErrorBoundary>
  );
}

export default ResultRenderer;
